(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-confirmation-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    const toastEl = document.getElementById('cart-toast');
    if (!toastEl) return;

    const imageEl = toastEl.querySelector('.cart-toast__image');
    const nameEl = toastEl.querySelector('.cart-toast__name');
    const metaEl = toastEl.querySelector('.cart-toast__meta');
    const priceEl = toastEl.querySelector('.cart-toast__price');
    const closeEl = toastEl.querySelector('.cart-toast__close');

    const AUTO_DISMISS_MS = 6000;
    let dismissTimer = null;

    function formatMoney(cents) {
      const openTag = '{' + '{';
      const closeTag = '}' + '}';
      const format = window.themeMoneyFormat || ('$' + openTag + 'amount' + closeTag);
      const amount = (cents / 100).toFixed(2);
      const amountNoDecimals = Math.round(cents / 100).toString();

      return format
        .replace(openTag + 'amount_no_decimals' + closeTag, amountNoDecimals)
        .replace(openTag + 'amount_with_comma_separator' + closeTag, amount.replace('.', ','))
        .replace(openTag + 'amount' + closeTag, amount);
    }

    function scheduleDismiss() {
      clearTimeout(dismissTimer);
      dismissTimer = setTimeout(hide, AUTO_DISMISS_MS);
    }

    function show() {
      toastEl.hidden = false;
      requestAnimationFrame(() => toastEl.classList.add('is-visible'));
      scheduleDismiss();
    }

    function hide() {
      clearTimeout(dismissTimer);
      toastEl.classList.remove('is-visible');
      setTimeout(() => {
        if (!toastEl.classList.contains('is-visible')) toastEl.hidden = true;
      }, 200);
    }

    document.addEventListener('busybee:cart:item-added', (event) => {
      const item = event.detail && event.detail.item;
      if (!item) return;

      nameEl.textContent = item.product_title || item.title || '';
      priceEl.textContent = formatMoney(item.final_line_price ?? item.line_price ?? item.price ?? 0);

      const metaParts = [event.detail.meshSize, event.detail.designSize].filter(Boolean);
      let metaText = metaParts.join(' • ');
      if (!metaText) {
        const variantTitle = item.variant_title;
        if (variantTitle && variantTitle !== 'Default Title') {
          metaText = variantTitle;
        }
      }
      metaEl.textContent = metaText;
      metaEl.hidden = !metaText;

      if (item.image) {
        imageEl.src = item.image;
        imageEl.hidden = false;
      } else {
        imageEl.removeAttribute('src');
        imageEl.hidden = true;
      }

      show();
    });

    if (closeEl) {
      closeEl.addEventListener('click', hide);
    }

    toastEl.addEventListener('mouseenter', () => clearTimeout(dismissTimer));
    toastEl.addEventListener('mouseleave', scheduleDismiss);
    toastEl.addEventListener('focusin', () => clearTimeout(dismissTimer));
    toastEl.addEventListener('focusout', scheduleDismiss);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductQuickAdd extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (this.button) {
        this.button.addEventListener('click', () => this.addToCart());
      }
    }

    async addToCart() {
      const variantId = this.dataset.variantId;
      if (!variantId || !this.button) return;

      this.button.disabled = true;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || 'Unable to add to cart');
        }

        document.dispatchEvent(
          new CustomEvent('busybee:cart:item-added', {
            bubbles: true,
            detail: {
              item: data,
              meshSize: this.dataset.meshSize,
              designSize: this.dataset.designSize,
            },
          })
        );
      } catch (error) {
        document.dispatchEvent(
          new CustomEvent('busybee:cart:error', {
            bubbles: true,
            detail: { error },
          })
        );
      } finally {
        this.button.disabled = false;
      }
    }
  }

  if (!customElements.get('product-quick-add')) {
    customElements.define('product-quick-add', ProductQuickAdd);
  }
  } catch(e) { console.error(e); }
})();

})();
